<template>
  <div class="formField text-left row">
    <!-- SE EMPIEZA A SELECIONAR DECIDIENDO DEL DATASHAPE DE LA BASE DE DATOS -->

    <div
      v-if="name == 'isAgency'"
      class="position-absolute isAgency col-6 col-sm-5 col-md-4 col-lg-3 col-xl-2 text-center ml-auto"
    >
      <input
        type="checkbox"
        class="hidden"
        :id="`klaus_${name}`"
        v-model="fieldValue"
        @change="onSave"
      />
      <label
        for="checkbox"
        :class="
          (fieldValue == false
            ? 'outlined-grey-isAgency bg-white'
            : ' bg-accent outlined-isAgency') + ' button '
        "
        >{{ "Agencias" }}</label
      >
    </div>
    <div v-else-if="type == 'link'">
      <label :for="`klaus_${name}`"
        ><h6 class="mt-1 mb-2 d-flex align-items-center">
          {{ label }}
          <p v-if="sub_label" class="subtext m-0 ml-2">
            {{ sub_label }}
          </p>
        </h6></label
      >
      <div class="link_form_container">
        <form v-on:submit.prevent>
          <input id="link_input" :value="fieldValue" disabled />
          <button
            v-clipboard:copy="fieldValue"
            v-clipboard:success="copyToClipboard"
            class="d-flex align-items-center justify-content-center"
          >
            <span>Copiar</span>
          </button>
        </form>
      </div>
    </div>
    <div
      v-else-if="
        (type == 'String' && !selectedObject.isAgency) ||
        (type == 'String' && selectedObject.isAgency)
          ? selectedObject.isAgency == formItem.isAgency
          : false
      "
      :class="{ error: $v.fieldValue.$error, correct: $v.fieldValue.$anyDirty }"
    >
      <label :for="`klaus_${name}`"
        ><h6 class="mt-1 mb-2 d-flex align-items-center">
          {{ label }}
          <p v-if="sub_label" class="subtext m-0 ml-2">
            {{ sub_label }}
          </p>
        </h6></label
      >
      <input
        :id="`klaus_${name}`"
        v-model="fieldValue"
        :placeholder="formItem.placeholder ? formItem.placeholder : ''"
      />
    </div>

    <div v-else-if="name == 'country'">
      <label
        ><h6 class="mt-1 mb-2">{{ label }}</h6></label
      >
      <multiselect
        openDirection="below"
        v-model="fieldValue"
        placeholder="Escoge tu país"
        label="nombre"
        track-by="nombre"
        :options="countries"
        :option-height="104"
        :custom-label="customLabel"
        :show-labels="false"
      >
        <template slot="singleLabel" slot-scope="props"
          ><img
            class="option__image"
            :src="
              'https://flagcdn.com/' + props.option.iso2.toLowerCase() + '.svg'
            "
            :alt="props.option.nombre"
          /><span class="option__desc"
            ><span class="option__title">{{ props.option.nombre }}</span></span
          ></template
        >
        <template slot="option" slot-scope="props"
          ><img
            class="option__image"
            :src="
              'https://flagcdn.com/' + props.option.iso2.toLowerCase() + '.svg'
            "
            :alt="props.option.nombre"
          />
          <div class="option__desc">
            <span class="option__title">{{ props.option.nombre }}</span>
          </div>
        </template>
      </multiselect>
    </div>
    <div
      v-else-if="
        type == 'phone_number' && selectedObject.client_contact.includes(name)
      "
      :class="{ error: $v.fieldValue.$error, correct: $v.fieldValue.$anyDirty }"
    >
      <p class="error" v-if="!$v.fieldValue.minLength">
        Numbero de teléfono debe tener almenos 7 caracteres
      </p>
      <input
        type="number"
        :id="`klaus_${name}`"
        v-model="fieldValue"
        @input="onSave"
        :placeholder="formItem.placeholder ? formItem.placeholder : ''"
      />
    </div>
    <div
      v-else-if="
        type == 'phone_number_code' &&
          selectedObject.client_contact.includes(name.split('_')[0])
      "
      :class="
        'phone_code_select ' +
          { error: $v.fieldValue.$error, correct: $v.fieldValue.$anyDirty }
      "
    >
      <label
        ><h6 class="mt-1 mb-2">
          {{ label }}
        </h6></label
      >
      <multiselect
        openDirection="below"
        v-model="fieldValue"
        placeholder="Pais"
        label="nombre"
        track-by="nombre"
        :options="countries"
        :option-height="104"
        :custom-label="customLabel"
        :show-labels="false"
        @input="phoneCodeSelected($event)"
      >
        <template slot="singleLabel" slot-scope="props">
          <span class="option__desc">
            <span class="option__title">+{{ props.option }} </span>
          </span>
          <img
            class="option__image"
            :src="
              'https://flagcdn.com/' +
                filteredPhoneCode(props.option)[0].iso2.toLowerCase() +
                '.svg'
            "
            :alt="props.option"
          />
        </template>
        <template slot="option" slot-scope="props"
          ><img
            class="option__image"
            :src="
              'https://flagcdn.com/' + props.option.iso2.toLowerCase() + '.svg'
            "
            :alt="props.option.nombre"
          />
          <div class="option__desc ml-2">
            <span class="option__title">{{ props.option.nombre }}</span>
          </div>
        </template>
      </multiselect>
    </div>
    <div
      v-else-if="
        (type == 'description' &&
          ($route.query.welcome == 'false' || !$route.query.welcome)) ||
          ($route.query.welcome == 'true' && Number($route.query.step) == 5)
      "
      :class="{ error: $v.fieldValue.$error, correct: $v.fieldValue.$anyDirty }"
    >
      <label :for="`klaus_${name}`"
        ><h6 class="mt-1 mb-2 d-flex align-items-center">
          {{ label }}
          <p v-if="sub_label" class="subtext m-0 ml-2">
            {{ sub_label }}
          </p>
        </h6></label
      >
      <textarea
        rows="12"
        :disabled="selectedObject.description_disabled"
        :id="`klaus_${name}`"
        v-model="fieldValue"
        minlength="150"
        :placeholder="formItem.placeholder ? formItem.placeholder : ''"
      />
    </div>
    <div v-else-if="type == 'textarea'">
      <span>{{ label }}</span>
      <textarea rows="8" :id="`klaus_${name}`" v-model="fieldValue" />
    </div>
    <div
      v-else-if="
        (type == 'Number' && !selectedObject.isAgency) ||
        (type == 'Number' && selectedObject.isAgency)
          ? selectedObject.isAgency == formItem.isAgency
          : false
      "
      :class="{ error: $v.fieldValue.$error, correct: $v.fieldValue.$anyDirty }"
    >
      <label :for="`klaus_${name}`"
        ><h6 class="mt-1 mb-2 d-flex align-items-center">
          {{ label }}
          <p v-if="sub_label" class="subtext m-0 ml-2">
            {{ sub_label }}
          </p>
        </h6></label
      >
      <input
        type="number"
        :id="`klaus_${name}`"
        v-model="fieldValue"
        @input="onSave"
        :placeholder="formItem.placeholder ? formItem.placeholder : ''"
      />
      <p class="error" v-if="!$v.fieldValue.minValue">
        La edad mínima son 18 años
      </p>
      <p
        class="error"
        v-if="!$v.fieldValue.required && $v.fieldValue.$anyDirty"
      >
        Campo requerido
      </p>
    </div>

    <div v-else-if="type == 'Boolean' && name !== 'map_active'">
      <span>{{ label }}</span>
      <input type="checkbox" :id="`klaus_${name}`" v-model="fieldValue" />
      <label for="checkbox">{{ fieldValue }}</label>
    </div>
    <div
      v-else-if="
        type == 'Select' ||
        (name == 'city' && !selectedObject.isAgency) ||
        (name == 'city' && selectedObject.isAgency)
          ? selectedObject.isAgency == formItem.isAgency
          : false
      "
      :class="{ error: $v.fieldValue.$error, correct: $v.fieldValue.$anyDirty }"
    >
      <label :for="`klaus_${name}`"
        ><h6 class="mt-1 mb-2">{{ label }}</h6></label
      >
      <select :id="`klaus_${name}`" v-model="fieldValue" @change="onSave">
        <option
          v-if="name !== 'has_place' && name !== 'delivery'"
          disabled
          selected
          :value="name == 'city' ? null : initialFieldValue"
          >{{ formItem.placeholder ? formItem.placeholder : "" }}</option
        >
        <option
          v-for="option in options"
          :key="option._id ? option._id : option.value"
          :value="option._id ? option._id : option.value"
          :selected="
            fieldValue == option._id
              ? fieldValue == option._id
              : fieldValue == option.value
          "
          >{{ `${option._id ? option.name : option.label}` }}</option
        >
      </select>
      <p
        class="error"
        v-if="$v.fieldValue.$anyDirty && !$v.fieldValue.required"
      >
        Campo requerido
      </p>
    </div>
    <div v-else-if="name == 'neighborhood' && selectedObject.has_place">
      <label
        ><h6 class="mt-1 mb-2">{{ label }}</h6>
      </label>
      <multiselect
        openDirection="below"
        v-model="fieldValueComputed"
        placeholder="Escoge tu barrio"
        label="name"
        track-by="_id"
        :options="options"
        :option-height="104"
        :show-labels="false"
      >
        <template slot="singleLabel" slot-scope="props">
          <span class="option__desc"
            ><span class="option__title">{{ props.option.name }}</span></span
          >
        </template>
        <template slot="option" slot-scope="props">
          <div class="option__desc">
            <span class="option__title">{{ props.option.name }}</span>
          </div>
        </template>
      </multiselect>
    </div>
    <div v-else-if="name == 'map_active' && selectedObject.has_place">
      <label
        ><h6 class="mt-1 mb-2">{{ label }}</h6>
      </label>
      <input type="checkbox" :id="`klaus_${name}`" v-model="fieldValue" />
    </div>
    <div v-else-if="name == 'location'">
      <label
        ><h6 class="mt-1 mb-2">{{ label }}</h6>
      </label>
      <input
        autoComplete="off"
        type="input"
        :id="`klaus_${name}`"
        v-model="fieldValue"
      />
    </div>
    <div v-else-if="type == 'media'" class="px-0">
      <p
        class="error text-center"
        v-if="$v.fieldValue.$anyDirty && !$v.fieldValue.minLength"
      >
        Debes tener al menos 4 fotos reales
      </p>
      <media-uploader
        :photos="photos"
        :media="selectedObject[name]"
        :objectId="user.kProfile"
        :collectionDBname="collectionDBname"
        :class="{
          error: $v.fieldValue.$error,
          correct: $v.fieldValue.$anyDirty,
        }"
        :name="name"
      />
    </div>
    <div v-else-if="name == 'places' && selectedObject.delivery" class="mt-1">
      <label
        ><p
          class="mt-1 mb-3 open-sans-regular text-rem-0-6 text-grey-dark text-uppercase"
        >
          {{ label }}
        </p></label
      >
      <div
        class="row align-items-start"
        :id="`klaus_${name}`"
        :custom_value="fieldValue"
      >
        <div class="col-6 my-2" v-for="option in options" :key="option._id">
          <div class="row align-items-center">
            <div class="col d-flex align-items-center">
              <input type="checkbox" :value="option._id" v-model="fieldValue" />

              <p class="checkbox-label m-0">{{ option.name }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else-if="type == 'checkbox-list' && name !== 'places'" class="">
      <label
        ><h6 class="mt-1 mb-2">{{ label }}</h6></label
      >
      <div
        class="row align-items-start"
        :id="`klaus_${name}`"
        :custom_value="fieldValue"
      >
        <div class="col-6 my-2" v-for="option in options" :key="option._id">
          <div class="row align-items-center">
            <div class="col px-1 d-flex align-items-center">
              <input type="checkbox" :value="option._id" v-model="fieldValue" />

              <p class="checkbox-label m-0">{{ option.name }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else-if="type == 'schedule'" class="container">
      <label
        ><h6 class="mt-1 mb-2">{{ label }}</h6></label
      >
      <schedule
        ref="klaus-schedule"
        :values="fieldValue"
        :formItem="formItem"
        class="container-fluid px-0"
        :disabled="kProfile.plan ? true : false"
        @onScheduleChange="changeEqualDays"
      />
    </div>
    <div class="px-0" v-else-if="type == 'chart'">
      <div class="px-3">
        <h4 class="m-0 poppins-bold">
          {{ sumChartValues(selectedObject[name + "s"].count) }} {{ label }}
        </h4>
        <p class="mt-1">{{ sub_label }}</p>
      </div>
      <chart
        :data="selectedObject[name + 's'].count"
        :labels="selectedObject[name + 's'].days"
        :legend="formItem.label"
      />
    </div>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect"
import MediaUploader from "@/components/UI/MediaUploader"
import Chart from "@/components/UI/Form/Chart"
import Schedule from "@/components/UI/Form/Schedule"
import { mapGetters } from "vuex"

import { required, minValue, minLength } from "vuelidate/lib/validators"
export default {
  data() {
    return {
      fieldValue: this.selectedObject[this.name],
      initialFieldValue: this.fieldValue,
      mediaQuantity: 0,
      equalDays: false,
    }
  },
  mounted() {
    /*  this.createHtmlElementOnDemand() */
    /* if (this.name == "schedule") {
      const model = this.fieldValue[0]
      let validation = Array.from(this.fieldValue).map(option => {
        if (
          option.active == model.active &&
          option.from == model.from &&
          option.to == model.to
        ) {
          console.log("ES IGUAL")
          return true
        } else {
          console.log("NO ES IGUAL")
          return false
        }
      })
      console.log("ESTA ES LA VALIDACION SCHEDULE", validation,
      validation.reduce())
    } */
    if (this.formItem.name == "agency_name") {
      this.fieldValue = ""
    }

    if (this.formItem.name == "location") {
      setTimeout(() => {
        this.initMap()
      }, 1000)
    }
  },
  methods: {
    async initMap() {
      console.log("Autocomplete loaded")
      let google = window.google
      let autocomplete = new google.maps.places.Autocomplete(
        document.getElementById("klaus_location"),
        {
          types: ["address"],
          componentRestrictions: {
            country: "co",
          },
          fields: ["geometry"],
        }
      )
      autocomplete.addListener("place_changed", () => {
        console.log(this, document.getElementById("klaus_location").value)
        this.fieldValue = document.getElementById("klaus_location").value
      })
    },
    copyToClipboard() {
      var copyText = document.getElementById("link_input")
      alert("La url de tu perfil: " + copyText.value)
    },
    sumChartValues(count) {
      return count.reduce(function(a, b) {
        return a + b
      }, 0)
    },
    changeEqualDays(value) {
      console.log("CHANGED EQUAL DAYS", value)
      this.equalDays = value
    },
    phoneCodeSelected(e) {
      console.log("ME SELECCIOONARON", this.fieldValue, e)
      this.fieldValue = e.phone_code
    },
    onSave() {
      console.log("ON SAVE LOG", this.name, this.fieldValue)
      if (this.name == "schedule" && this.fieldValue.equalDays) {
        const sch_component = this.$refs["klaus-schedule"]
        const scheduleComponent = sch_component.saveSchedule()

        const toDate = scheduleComponent[0].to
        const fromDate = scheduleComponent[0].from
        const schedule = scheduleComponent.map(day => {
          day.active = true
          day.allDay = false
          day.to = toDate
          day.from = fromDate
          return day
        })

        console.log(" EUQAL DAYS", schedule, this.name, this.formItem.equalDays)
        this.$emit("onChange", {
          name: this.name,
          value: schedule,
        })
        return { status: true, name: this.name, value: schedule }
      } else if (this.name == "schedule" && !this.fieldValue.equalDays) {
        const sch_component = this.$refs["klaus-schedule"]
        const scheduleComponent = sch_component.saveSchedule()

        console.log(
          "ON SAVE LOG NORMAL",
          scheduleComponent,
          this.name,
          this.formItem.equalDays
        )
        this.$emit("onChange", {
          name: this.name,
          value: scheduleComponent,
        })
        return { status: true, name: this.name, value: scheduleComponent }
      } else {
        this.$v.fieldValue.$touch()
        if (this.$v.$invalid) {
          console.log("FORMA INVALIDA")
          return { status: false, name: this.name, value: this.fieldValue }
        } else {
          console.log("FORMA VALIDA")
          this.$emit("onChange", { name: this.name, value: this.fieldValue })
          return { status: true, name: this.name, value: this.fieldValue }
        }
      }
    },
    createHtmlElementOnDemand() {
      if (this.type == "checkbox-list") {
        console.log("checkbox", this.fieldValue, this.options)
        let indexes = this.options.map((option, index) => {
          // we will search on the fewers, the selected options
          let filtering = this.fieldValue.map(selected => {
            const condition = selected == option._id
            //console.log(condition, "condition")
            return condition ? true : null
          })
          filtering = filtering.filter(o => !!o)
          if (filtering.length > 0) return index
          else return null
        })
        indexes = indexes.filter(o => !!o)
        console.log(indexes)
      }
    },
    customLabel({ nombre, iso2 }) {
      return `${nombre} – ${iso2}`
    },
    customLabelSelect({ name }) {
      return `${name}`
    },
    filteredPhoneCode(code) {
      return this.countries.filter(country => {
        return country.phone_code == code
      })
    },
    onSelectChange() {
      console.log(
        "ESTO VOY A GUARDAR EN SELECT",
        this.name,
        this.fieldValue,
        !this.fieldValue
      )
      this.$emit("onChange", { name: this.name, value: this.fieldValue })
    },
  },
  components: {
    Multiselect,
    MediaUploader,
    Chart,
    Schedule,
  },
  props: [
    "formItem",
    "name",
    "label",
    "sub_label",
    "type",
    "options",
    "selectedObject",
    "newObject",
    "collectionDBname",
  ],
  computed: {
    ...mapGetters(["countries", "user", "photos", "kProfile"]),
    fieldValueComputed: {
      get() {
        if (this.name == "neighborhood") {
          const selectedOption = this.options.filter(option => {
            return option._id == this.fieldValue
          })
          console.log("GETTED KPROFILE", selectedOption[0])
          return selectedOption[0]
        } else {
          return { _id: String }
        }
      },
      set(newFieldValue) {
        console.log(newFieldValue, this.name)
        this.fieldValue = newFieldValue._id
      },
    },
    routerQuery() {
      return this.$route.query
    },
    /* fieldValue: {
      get() {
        return this.selectedObject[this.name]
      },
      set(newFieldValue) {
        console.log(newFieldValue, this.name)
        return newFieldValue
      },
    }, */
  },
  validations() {
    if (this.name == "age") {
      return {
        fieldValue: {
          required,
          minValue: minValue(18),
        },
      }
    } else if (
      this.name == "category" ||
      (this.name == "city" && !this.selectedObject.isAgency) ||
      (this.name == "city" && this.selectedObject.isAgency)
        ? this.selectedObject.isAgency == this.formItem.isAgency
        : false
    ) {
      return {
        fieldValue: {
          required,
        },
      }
    } else if (
      (this.name == "name" && !this.selectedObject.isAgency) ||
      (this.name == "agency_name" && !this.selectedObject.isAgency) ||
      (this.name == "name" && this.selectedObject.isAgency) ||
      (this.name == "agency_name" && this.selectedObject.isAgency)
        ? this.selectedObject.isAgency == this.formItem.isAgency
        : false
    ) {
      return {
        fieldValue: {
          required,
          minLength: minLength(3),
        },
      }
    } else if (
      this.type == "phone_number" &&
      (this.selectedObject.client_contact == "whatsapp & phone" ||
        this.selectedObject.client_contact == this.name)
    ) {
      return {
        fieldValue: {
          required,
          minLength: minLength(7),
        },
      }
    } else if (
      this.type == "phone_number_code" &&
      (this.selectedObject.client_contact == "whatsapp & phone" ||
        this.selectedObject.client_contact == this.name.split("_")[0])
    ) {
      return {
        fieldValue: {
          required,
        },
      }
    } else if (this.type == "description") {
      return {
        fieldValue: {
          minLength: minLength(150),
          required,
        },
      }
    } else if (this.formItem.required) {
      return {
        fieldValue: {
          required,

          minValue: false,
        },
      }
    } else if (this.name == "portfolio" && this.formItem.media_type) {
      console.log("DENTRO DE VALID PORFOLIO", this.formItem, this.fieldValue)
      if (this.photos.portfolio.length > 3) {
        return {
          fieldValue: {
            required: false,
            minValue: false,
            minLength: false,
          },
        }
      } else {
        return {
          fieldValue: {
            required,
            minLength: minLength(3),
          },
        }
      }
    } else {
      return {
        fieldValue: {
          required: false,
          minValue: false,
          minLength: false,
        },
      }
    }
  },
}
</script>

<style lang="scss">
.link_form_container {
  form {
    /* This bit sets up the horizontal layout */
    display: flex;
    flex-direction: row;

    border: 1.2px solid #e0e0e0;
    box-sizing: border-box;
    border-radius: 2px;
    height: 41px;
  }

  input {
    /* Tell the input to use all the available space */
    flex-grow: 2;
    /* And hide the input's outline, so the form looks like the outline */
    border: none;
    background-color: white;
  }
  input:disabled {
    background-color: white;
  }

  input:focus {
    /* removing the input focus blue box. Put this on the form if you like. */
    outline: none;
  }

  button {
    /* Just a little styling to make it pretty */
    background: #665dc3;
    border-radius: 5px;
    width: 84px;
    height: 25px;
    align-self: center;
    padding: 0 !important;
    margin-right: 10px;
    span {
      font-style: normal;
      font-weight: bold;
      font-size: 11px;
      color: white;
    }
  }
}
.isAgency {
  right: 15px;
  top: 10px;
}
</style>
